import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, ACCESS_KEY, REFRESH_KEY, setUnauthorizedHandler } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [initialized, setInitialized] = useState(false);

  const logout = useCallback(() => {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem("fuelops_active_station_id");
    setUser(false);
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      logout();
    });
  }, [logout]);

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_KEY);
    if (!token) {
      setUser(false);
      setInitialized(true);
      return;
    }
    api
      .me()
      .then((u) => {
        setUser(u);
        setInitialized(true);
      })
      .catch(() => {
        logout();
        setInitialized(true);
      });
  }, [logout]);

  const login = async (email, password) => {
    const res = await api.login({ email, password });
    localStorage.setItem(ACCESS_KEY, res.access_token);
    localStorage.setItem(REFRESH_KEY, res.refresh_token);
    setUser(res.user);
    return res.user;
  };

  const register = async (email, password, name) => {
    const res = await api.register({ email, password, name });
    localStorage.setItem(ACCESS_KEY, res.access_token);
    localStorage.setItem(REFRESH_KEY, res.refresh_token);
    setUser(res.user);
    return res.user;
  };

  return (
    <AuthContext.Provider value={{ user, initialized, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
